import React from 'react'
import './services.css'
import { MdDesignServices } from 'react-icons/md'

const Services = () => {
  return (
    <section id='services'>
      <h5>What WE Do</h5>
      <h2>Services</h2>

      <div className='container services__container'>
        
        {/* Second article */}
        <article className='service'>
          <div className='service__head'>
            <h3>Web Development</h3>
          </div>
          <ul className='service__list'>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Develop and maintained scalable backend solutions for your Web Applications.</p>
            </li>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Collaborate with cross-functional teams to define project requirements and specifications.</p>
            </li>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Troubleshot and resolved backend issues and bugs in a timely manner.</p>
            </li>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>We purchase a secured domain and hosting for your project.</p>
            </li>
          </ul>
        </article>
        <article className='service'>
          <div className='service__head'>
            <h3>UI/UX Design</h3>
          </div>
          <ul className='service__list'>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Do professional industrial design and product development</p>
            </li>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Develop concepts for client products.</p>
            </li>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Design and develop any product prototype for clients.</p>
            </li>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Provide a visual feel of your website before development.</p>
            </li>
          </ul>
        </article>
        {/* Second article */}
        <article className='service'>
          <div className='service__head'>
            <h3>Rest APIs & Database</h3>
          </div>
          <ul className='service__list'>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Designed and implement databases from scratch</p>
            </li>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Designed and implement RESTfull APIs and web services.</p>
            </li>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Optimized database queries and performance for improved system efficiency.</p>
            </li>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Conduct code reviews and provide constructive feedback to team members.</p>
            </li>
          </ul>
        </article>
        {/* Second article */}

        <article className='service'>
          <div className='service__head'>
            <h3>Machine Learning and AI Services</h3>
          </div>
          <ul className='service__list'>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Designed and implement a complete chatbot for your business</p>
            </li>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Implement a custom dashboard to visualize data in real time.</p>
            </li>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Data Cleaning, Preprocessing, and Visualization.</p>
            </li>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Building machine learning models with good metrics.</p>
            </li>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Build a sentiment analysis or customer feedback analysis system for 
                decision making to further optimize customer retention.</p>
            </li>
          </ul>
        </article>
        <article className='service'>
          <div className='service__head'>
            <h3>Courses</h3>
          </div>
          <ul className='service__list'>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Java, Python and Javascript.</p>
            </li>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Spring Boot, Spring Cloud, Microservices.</p>
            </li>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>DevOps, AWS, CICD and Containerization.</p>
            </li>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Backend and Frontend Development.</p>
            </li>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Machine Learning.</p>
            </li>
            <li>
              <MdDesignServices className='service__list-icon'/>
              <p>Data Structure and Algorithms.</p>
            </li>
          </ul>
        </article>
        <article className='service'>
          <div className='service__head'>
            <h3>Mentorship</h3>
          </div>
          <ul className='service__list'>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Provide a heads up on current trends in the industry for better decision making.</p>
            </li>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>A F2F online meet to clear your doubts and help you decide on the best career path.</p>
            </li>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Code reviews with Practical Walkthrough.</p>
            </li>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Seminar.</p>
            </li>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>Resume Review Services.</p>
            </li>
            <li>
              <MdDesignServices className='service__list-icon' />
              <p>.... And many more based on your demand</p>
            </li>
          </ul>
        </article>
      </div>
    </section>
  )
}

export default Services